<template>
  <el-card class="box-card">
    <div slot="header" class="pob-header">
      <span>{{ $t("caixa-postal") }}</span>
      <el-button size="mini" icon="el-icon-plus" type="primary" @click="open()">Nova caixa postal</el-button>
    </div>

    <el-table
      :data="records"
      stripe
      size="mini"
      style="width: 100%"
      empty-text="Nenhuma caixa postal cadastrada"
      @row-dblclick="open"
    >
      <el-table-column prop="name" :label="$t('nome')" min-width="180" show-overflow-tooltip></el-table-column>
      <el-table-column label="Tipo" min-width="150">
        <template slot-scope="scope">{{ typeLabel(scope.row) }}</template>
      </el-table-column>
      <el-table-column :label="$t('endereco')" min-width="340" show-overflow-tooltip>
        <template slot-scope="scope">{{ fullAddress(scope.row) }}</template>
      </el-table-column>
      <el-table-column label="UFs atendidas" min-width="200">
        <template slot-scope="scope">
          <el-tag v-for="uf in scope.row.ufs" :key="uf" size="mini" class="pob-uf" disable-transitions>{{ uf }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="#" width="80" fixed="right">
        <template slot-scope="scope">
          <i class="el-icon-edit-outline pob-action" title="Editar caixa postal" @click="open(scope.row)"></i>
          <i class="el-icon-delete pob-action" title="Excluir caixa postal" @click="remove(scope.row)"></i>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="form.id ? 'Editar caixa postal' : 'Nova caixa postal'" :visible.sync="dialog" width="60%">
      <el-form :model="form" :rules="rules" ref="form" label-position="top" size="small">
        <el-row :gutter="12">
          <el-col :xs="24" :sm="10">
            <el-form-item label="Tipo" prop="type">
              <el-radio-group v-model="form.type">
                <el-radio label="caixa_postal">Caixa postal (AGF)</el-radio>
                <el-radio label="filial">Filial +Envios</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col v-if="form.type === 'caixa_postal'" :xs="24" :sm="6">
            <el-form-item label="Nº da caixa postal" prop="boxNumber">
              <el-input v-model="form.boxNumber" maxlength="10"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('nome')" prop="name">
          <el-input v-model="form.name" maxlength="50"></el-input>
        </el-form-item>
        <el-row :gutter="12">
          <el-col :xs="24" :sm="6">
            <el-form-item :label="$t('cep')" prop="zipcode">
              <el-input v-model="form.zipcode" maxlength="9" v-mask="'#####-###'" @blur="zipcode(form)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item :label="$t('endereco')" prop="address">
              <el-input v-model="form.address" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item :label="$t('numero')" prop="number">
              <el-input v-model="form.number" maxlength="6"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :xs="24" :sm="8">
            <el-form-item :label="$t('complemento')" prop="complement">
              <el-input v-model="form.complement" maxlength="40"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item :label="$t('bairro')" prop="neighborhood">
              <el-input v-model="form.neighborhood" maxlength="40"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item :label="$t('cidade')" prop="city">
              <el-input v-model="form.city" maxlength="40"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="4">
            <el-form-item :label="$t('estado')" prop="state">
              <el-select v-model="form.state" filterable>
                <el-option v-for="uf in ufs" :key="uf" :label="uf" :value="uf"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="UFs atendidas (UF do consumidor que posta para esta caixa postal)" prop="ufs">
          <el-select v-model="form.ufs" multiple filterable placeholder="Selecione as UFs">
            <el-option
              v-for="uf in ufs"
              :key="uf"
              :label="owner(uf) ? `${uf} (${owner(uf)})` : uf"
              :value="uf"
              :disabled="!!owner(uf)"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialog = false">{{ $t("cancelar") }}</el-button>
        <el-button type="primary" @click="submit">{{ form.id ? $t("atualizar") : $t("adicionar") }}</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>
<script>
import { PostOfficeBoxService } from "@/services/post.office/post.office.box.services";
import { i18n } from "@/plugin/i18n";
import ZipMixins from "@/xpost/mixins/zipcode";

const UFS = [
  "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS", "MG", "PA",
  "PB", "PR", "PE", "PI", "RJ", "RN", "RS", "RO", "RR", "SC", "SP", "SE", "TO",
];
const EMPTY = {
  id: "", type: "caixa_postal", boxNumber: "", name: "", zipcode: "", address: "", number: "", complement: "",
  neighborhood: "", city: "", state: "", ufs: [],
};
const required = (message) => [{ required: true, message, trigger: "blur" }];

// Destinos da Reversa Consolidada (TASK-1808): a UF do consumidor escolhe a caixa postal (AGF)
// ou a filial +Envios que recebe a postagem local dos Correios.
export default {
  name: "PostOfficeBox",
  mixins: [ZipMixins],
  data() {
    return {
      ufs: UFS,
      records: [],
      dialog: false,
      form: { ...EMPTY },
      rules: {
        boxNumber: [{
          trigger: "blur",
          validator: (rule, value, callback) =>
            this.form.type === "caixa_postal" && !value ? callback(new Error("Nº da caixa postal é obrigatório")) : callback(),
        }],
        name: required(i18n.tc("nome-obrigatorio")),
        zipcode: required("CEP é obrigatório"),
        address: required("Endereço é obrigatório"),
        number: required("Número é obrigatório"),
        neighborhood: required("Bairro é obrigatório"),
        city: required("Cidade é obrigatória"),
        state: required("UF é obrigatória"),
      },
    };
  },
  methods: {
    typeLabel(row) {
      return row.type === "filial" ? "Filial +Envios" : `Caixa postal ${row.boxNumber || ""}`;
    },
    fullAddress(row) {
      const cep = `${row.zipcode.slice(0, 5)}-${row.zipcode.slice(5)}`;
      const complement = row.complement ? ` ${row.complement}` : "";
      return `${row.address}, ${row.number}${complement} – ${row.neighborhood} – ${row.city}/${row.state} – CEP ${cep}`;
    },
    // Nome da outra caixa postal que já atende a UF (cada UF aponta para uma só).
    owner(uf) {
      const box = this.records.find((x) => x.id !== this.form.id && x.ufs.includes(uf));
      return box ? box.name : "";
    },
    withLoading(promise) {
      const loading = this.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      return promise
        .catch((error) => {
          this.$message({ type: "error", message: [].concat(error).join(" ") });
          throw error;
        })
        .finally(() => loading.close());
    },
    fetchRecords() {
      this.withLoading(PostOfficeBoxService.list())
        .then((records) => (this.records = records))
        .catch(() => {});
    },
    open(row) {
      this.form = row
        ? { ...row, ufs: [...row.ufs], complement: row.complement || "", boxNumber: row.boxNumber || "" }
        : { ...EMPTY, ufs: [] };
      this.dialog = true;
      this.$nextTick(() => this.$refs.form.clearValidate());
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        const { id, ...payload } = this.form;
        const request = id ? PostOfficeBoxService.update(id, payload) : PostOfficeBoxService.add(payload);
        this.withLoading(request)
          .then(() => {
            this.$message({ type: "success", message: "Caixa postal salva!" });
            this.dialog = false;
            this.fetchRecords();
          })
          .catch(() => {});
      });
    },
    remove(row) {
      this.$confirm(
        `Excluir a caixa postal ${row.name}? As UFs ${row.ufs.join(", ") || "-"} ficam sem caixa postal.`,
        i18n.tc("aviso"),
        { confirmButtonText: "OK", cancelButtonText: i18n.tc("cancelar"), type: "warning", center: true }
      )
        .then(() => this.withLoading(PostOfficeBoxService.delete(row.id)))
        .then(() => {
          this.$message({ type: "success", message: "Caixa postal excluída!" });
          this.fetchRecords();
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.fetchRecords();
  },
};
</script>
<style scoped>
.pob-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pob-uf {
  margin-right: 4px;
}
.pob-action {
  font-size: 16px;
  color: #606266;
  cursor: pointer;
  margin-left: 6px;
}
.pob-action:hover {
  opacity: 0.65;
}
.el-select {
  width: 100%;
}
</style>
